import {Component, Input} from '@angular/core';
import {NavItem} from '../../../../models/nav-item.model';
import {NavService} from '../../../../services/nav.service';

@Component({
    selector: 'app-nav-tile',
    templateUrl: './nav-tile.component.html',
    styleUrls: ['./nav-tile.component.less'],
})
export class NavTileComponent {
    @Input() item: NavItem;

    constructor(private navService: NavService) {}

    onClick() {
        if (this.item) {
            this.navService.handleDispatch(this.item);
        }
    }
}
